<template>
  <CommonModal>
    <template slot="header">
      <h3>Change Order</h3>
    </template>
    <template slot="body">
      <div @click="sortTpcd" id="tpcdList" class="arrow">
        Sort
      </div>
      <draggable  v-model="form.tpcdList">
        <div v-for="item in form.tpcdList" :key="item.tpcdId" class="order-box">
          {{ item.tpcdName }}
        </div>
      </draggable>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import $ from "jquery";
import {getTpcdList, updateTpcdOrder} from "@/api/tpcd";
import draggable from 'vuedraggable'
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal ,
    draggable
  },
  data() {
    return {
      form : {
        tpcdList: [],
      },
    };
  },
  methods: {
    async fetchData(upperId){
      try {
        const response = await getTpcdList(upperId);
        this.form.tpcdList = response.data.tpcdList;
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      await this.form.tpcdList.forEach(function (item, index) {
        item.tpcdSort = index;
      });
      await updateTpcdOrder(this.form);
    },
    sortTpcd(){
      let tmp = this.form.tpcdList;
      let sortdir = 1;
      if($("#tpcdList").is(".up")){
        $("#tpcdList").removeClass("up");
        $("#tpcdList").addClass("down")
        sortdir = -1;
      }else{
        $("#tpcdList").addClass("up");
        $("#tpcdList").removeClass("down")
        sortdir = 1;
      }
      tmp.sort((a, b) => {
        let x = a.tpcdName.toUpperCase();
        let y = b.tpcdName.toUpperCase();
        return (x < y)?-sortdir:(x>y)?sortdir:0;
      });
      this.form.tpcdList = tmp;
    }
  }
}
</script>

<style>

.arrow{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    border-bottom: 1px solid #e0e0e0;
}

.arrow:hover{
  cursor: pointer;
}

.up{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    background: url(../../img/background/fillter_arr_up.png) no-repeat right 50%;
}

.down{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    background: url(../../img/background/fillter_arr_down.png) no-repeat right 50%;
}
</style>